<template>
    <div>
        <div class="box have-relative mb-2 mx-1">
            <div v-if="editable" class="corner-buttons">
                <a @click="editNote">
                    <Icon family="fal" name="fa-pencil" />
                </a>
                <a @click="openConfirmRemoveNote">
                    <Icon family="fas" name="fa-times-circle" />
                </a>
            </div>
            <p class="has-text-weight-bold is-size-5">{{ note.title }}</p>
            <component :is="noteComponent" :note="note" />
        </div>
        <NoteBuilder
            v-if="showEditNote"
            :type="note.type"
            :noteId="note.id"
            @close="closeNoteBuilder"
        />
        <ConfirmRemoveNoteModal
            v-if="showConfirmRemoveNote"
            :noteId="note.id"
            @close="closeConfirmRemoveNote"
        />
    </div>
</template>

<script>
import { noteTypes } from "@/config/index.js";
import NoteBuilder from "./NoteBuilder.vue";
import ConfirmRemoveNoteModal from "./ConfirmRemoveNoteModal";
import PlainTextNote from "./types/PlainTextNote";
import SoapNote from "./types/SoapNote";

export default {
    name: "note",
    components: {
        NoteBuilder,
        ConfirmRemoveNoteModal,
    },
    props: {
        note: {
            type: Object,
            required: true,
        },
        editable: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            showEditNote: false,
            showConfirmRemoveNote: false,
        };
    },
    computed: {
        noteComponent() {
            switch (this.note.type) {
                case noteTypes.plainText:
                    return PlainTextNote;
                case noteTypes.soap:
                    return SoapNote;
            }
            return null;
        },
    },
    methods: {
        editNote() {
            this.showEditNote = true;
        },
        closeNoteBuilder() {
            this.showEditNote = false;
        },
        openConfirmRemoveNote() {
            this.showConfirmRemoveNote = true;
        },
        closeConfirmRemoveNote() {
            this.showConfirmRemoveNote = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.corner-buttons {
    position: absolute;
    top: 1px;
    right: 1px;
}

.have-relative {
    position: relative;
}
</style>